// extracted by mini-css-extract-plugin
export default {"primary_button":"primary-button_primary_button__-uGVm","icon_wrapper":"primary-button_icon_wrapper__Xr+4g"};